import { useState } from 'react';
import { generateSecurePassword } from '../../utils/password';

interface GeneratePasswordActionProps {
  /** Recibe la contraseña generada para volcarla en el/los campos correspondientes. */
  onGenerate: (password: string) => void;
  disabled?: boolean;
}

/**
 * Botón para el `labelAction` de un campo de contraseña nueva: genera una
 * contraseña segura, la vuelca en el campo (vía onGenerate) y la copia al
 * portapapeles para que el usuario pueda guardarla.
 */
export function GeneratePasswordAction({ onGenerate, disabled }: GeneratePasswordActionProps) {
  const [copied, setCopied] = useState(false);

  async function handleClick() {
    const password = generateSecurePassword();
    onGenerate(password);
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // El portapapeles puede estar bloqueado; la contraseña ya queda en el campo.
    }
  }

  return (
    <button type="button" className="ui-field__action" disabled={disabled} onClick={handleClick}>
      {copied ? 'Generada y copiada ✓' : 'Generar y copiar'}
    </button>
  );
}
